//
//
//
//
//
//
//

import Drip from 'drip';

// 项目详情页的广告位
export default {
  props: {
    performanceInfo: {
      type: Object,
      default: null
    }
  },
  methods: {
    navigateByAdSettings: function navigateByAdSettings() {
      var performanceInfo = this.performanceInfo;
      var projectServing = performanceInfo.projectServing;
      if (projectServing) {
        var servingType = projectServing.servingType,
          servingURL = projectServing.servingURL;
        if (servingType === 1) {
          // 详情
          var nextDestination = "/myshow/index.html#/detail/".concat(servingURL);
          Drip.redirect(nextDestination);
        } else if (servingType === 2) {
          // 魔方
          Drip.redirect(servingURL);
        }
      }
    }
  }
};